import AIRRReport from "./AIRRReport";

export default AIRRReport;
